import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/sales')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/sale' })
  },
})
